/**
 * 들은 얘기(SPEC_CHANGE_v1.3 5장 · C-13 · DEV-14). 서버와 화면이 같이 씀.
 */

/** 별채 부르기 칩: 누르면 그 멤버 1:1 로 가서 첫마디로 속 얘기를 꺼냄 */
export const DEEP_CALL_CHIP = '1:1에서 들을게';

/** 부르기 시간(한국 시각): 낮에 1:1 을 열 틈을 먼저 주고, 저녁 이야기 자리에서 */
export const DEEP_CALL_HOURS = { from: 19, to: 21 };

/** 첫마디 뒤 단골 말 몇 번까지 그 멤버가 속 얘기를 맥락으로 아는지 */
export const DEEP_STORY_CONTEXT_TURNS = 6;
